import _ from 'underscore';
import $ from 'jquery';

export default class Offers {
  constructor($scope, $rootScope, $q, OfferCampaignService, OfferService, PaginationService, UserService) {
    function set_supplier_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.supplier_id = ui.item.id;
          $scope.$apply();
        }
      });
    }

    function set_buyer_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.buyer_id = ui.item.id;
          $scope.$apply();
        }
      });
    }

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

    $scope.check_offers = function() {
      _.each($scope.offers, function(c) {
        c.checked = $scope.select_all;
      });
    };

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.load_data = function() {
      $scope.select_all = false;
      OfferService.get_manage_data($scope.filter).then(function(data) {
        $scope.offers = data.offers;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
      });
    };

    $scope.get_stocklist_percentage = function(offer) {
      if (offer.stocklist_count === 0 || offer.stocklist_product_count === 0)
        return 0;
      else
        return parseInt(offer.stocklist_product_count / offer.stocklist_count * 100);
    };

    $scope.get_description_percentage = function(offer) {
      var percentage = 0;
      if (offer.subtitleEN)
        percentage += 33;
      if (offer.full_description)
        percentage += 33;
      if (offer.notes)
        percentage += 34;
      return percentage;
    };

    $scope.get_status_css_class = function(offer) {
      if (offer.is_deleted)
        return 'red';
      else if (offer.visible && offer.is_active)
        return 'green';
      else if (!offer.visible && offer.is_active)
        return 'orange';
      else
        return '';
    };

    $scope.get_offer_ids = function() {
      return _.pluck($scope.offers, 'id').join(', ');
    };

    $scope.create_offer_campaigns = function() {
      var offers = _.where($scope.offers, {
        checked: true
      });
      if (offers.length === 0) {
        alert('Please select at least one offer!');
        return;
      }

      var campaigns = [];

      offers.reduce(function(promise, offer, index) {
        return promise.then(function(result) {
          if (result) {
            campaigns.push(result.campaign_id);
          }

          var deferred = $q.defer();

          var data = {
            offer_id: offer.id,
            campaign_settings: offer.offer_campaign_settings,
            deferred: deferred,
            total_count: offers.length,
            current_index: index
          };
          $rootScope.$broadcast('show_create_campaign', data);

          return deferred.promise;
        });
      }, $q.when())
      .then(function(result) {
        campaigns.push(result.campaign_id);

        OfferCampaignService.send_created_campaigns_email(campaigns);
      });
    };

    $scope.init_filter = function() {
      $scope.filter = {
        page: 1,
        per_page: 50,
        sort_by: null,
        sort_by_mode: 1,
        supplier_id: null,
        buyer_id: null,
        id: null,
        title: null,
        date_from: null,
        date_to: null,
        is_deleted: null,
        is_personalized: null,
        is_primary: true
      };
    };

    $scope.init = function() {
      $scope.offers = [];
      $scope.pagination = {};
      set_supplier_company_autocomplete($('input.supplier_company'));
      set_buyer_company_autocomplete($('input.buyer_company'));
      $scope.init_filter();
      $scope.load_data();
    };

    $scope.init();
  }
}

Offers.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService', 'OfferService', 'PaginationService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offers.ctrl.js